import { OCCURRENCE_TYPE_LABELS } from "./constants.js";
import { formatCompactMinutes } from "./format-minutes.js";
//#region src/modules/ServicePeriods/activity-evals/format-occurrence-tag.ts
function formatOccurrenceTag(occurrence) {
	switch (occurrence.type) {
		case "cadence": return `${OCCURRENCE_TYPE_LABELS.cadence} (every ${formatCompactMinutes(occurrence.cadenceMinutes)})`;
		case "continuous": return OCCURRENCE_TYPE_LABELS.continuous;
		case "count": return `${OCCURRENCE_TYPE_LABELS.count} (x${occurrence.minCount})`;
	}
}
//#endregion
export { formatOccurrenceTag };

//# sourceMappingURL=format-occurrence-tag.js.map